import React from 'react';
import ProductItemView from '../ProductItemViewMobile';
import adaptability from '../../resource/lis_mobile/adaptability.png';


const AdaptabilityMobile = () => {
    return (
        <ProductItemView
            title="Adaptabilidad"
            items={["Conexión con sistemas de facturación o cotización", "Integramos todos los analizadores o sistemas a través de nuestro middleware", "Soporte de solicitudes medicas electrónicas"]}
            image={adaptability} />
    );
};

export default AdaptabilityMobile;